import { Controller, useFormContext } from 'react-hook-form';
import { MenuDropdown, MenuItem } from '@features/events/common';
import { ArrowDown, Group, OnlineIcon } from '@shared/assets';
import { useCommonMenu } from '@shared/ui';
import * as st from './styles.module.scss';

type Mode = 'O' | 'N';

const modeOptions: Record<Mode, { icon: JSX.Element; label: string }> = {
  N: { icon: <OnlineIcon />, label: 'Онлайн' },
  O: { icon: <Group />, label: 'Лично' },
};

export const Mode = (): JSX.Element => {
  const { control } = useFormContext();
  const { onClose, onOpen, popperEl, referenceEl, setPopperEl, setReferenceEl } = useCommonMenu();

  const renderMenuItem = (mode: Mode, onChange: (value: Mode) => void) => (
    <MenuItem
      key={mode}
      onClick={(e) => {
        onChange(mode);
        onClose(e);
      }}
      className={st.mode__item}
    >
      <>
        {modeOptions[mode].icon}
        <span>{modeOptions[mode].label}</span>
      </>
    </MenuItem>
  );

  return (
    <Controller
      name="mode"
      control={control}
      render={({ field: { value, onChange } }) => (
        <div className={st.mode}>
          <div className={st.mode__switch} onClick={onOpen} ref={setReferenceEl}>
            <div className={st.currentValue}>
              {modeOptions[value as Mode].icon}
              <span>{modeOptions[value as Mode].label}</span>
            </div>
            <ArrowDown />
            <MenuDropdown popperEl={popperEl} referenceEl={referenceEl} setPopperEl={setPopperEl}>
              {(['O', 'N'] as Mode[]).map((mode) => renderMenuItem(mode, onChange))}
            </MenuDropdown>
          </div>
        </div>
      )}
    />
  );
};
